import { useEffect } from 'react';

export const useTitle = (title: string) => {
  useEffect(() => {
    const fullTitle = `ChangeGPS - ${title}`;
    document.title = fullTitle;

    if (window.top && window.top !== window) {
      window.top.document.title = fullTitle;
    }
  }, [title]);
};
